<ng-container *ngIf="!loading; else loadingTemp">
    <div
        *ngIf="selected && !changeMode; else selectTemp"
        fxFlex="0 0 100%"
        class="selected-wrapper"
        fxLayout="row wrap"
    >
        <ng-container *ngIf="selected.number_of_items > 0">
            <ng-container *ngIf="resourceItems$ | async; let resourceItems; else: loadingTemp">
                <ng-container *ngIf="!!resourceItems.length">
                    <div class="file-parent-wrap-items">
                        <div class="title-item">{{ resourceItems[currentIndex].title }}</div>
                        <div
                            *ngIf="resourceItems[currentIndex].isDocType()"
                            fxLayout="column"
                            class="file-parent-wrap-items-item"
                            fxLayoutAlign="center start"
                        >
                            <app-media-view [media_id]="resourceItems[currentIndex].name"> </app-media-view>
                            <mat-checkbox
                                [checked]="resourceItems[currentIndex].can_download"
                                (change)="toggleDownload(resourceItems[currentIndex].id, $event.checked)"
                                color="primary"
                                class="can-download-wrapper mb-1"
                            >
                                <div class="can-download" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                                    <mat-icon class="material-icons-outlined">download_for_offline</mat-icon>
                                    <span fxLayoutAlign="start center" fxLayoutGap="5px">
                                        <span i18n>Learners can download</span>
                                    </span>
                                </div></mat-checkbox
                            >
                        </div>
                        <div class="item-content w-100">
                            <div
                                *ngIf="resourceItems[currentIndex].item_type_value === 'text_material'"
                                [innerHtml]="resourceItems[currentIndex].name | innerHtml : 'tool_desc'"
                            ></div>
                            <app-media-view
                                *ngIf="resourceItems[currentIndex].item_type_value === 'url_material'"
                                [media_id]="resourceItems[currentIndex].name"
                            ></app-media-view>
                        </div>
                        <div
                            class="item-container-player"
                            *ngIf="resourceItems[currentIndex].item_type_value === 'item_container'"
                        >
                            <app-material-item-container-player [parentItem]="resourceItems[currentIndex]">
                            </app-material-item-container-player>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-container>

<ng-template #selectTemp>
    <app-course-manager-core-add-material
        [display]="ResourceBuildingItems.MATERIAL_LIBRARY"
        (selectChange)="selectResource($event.value); onChangeMode(false)"
        (onCloseView)="onChangeMode(false)"
    ></app-course-manager-core-add-material>
</ng-template>

<ng-template #loadingTemp>
    <div fxLayout="row" fxLayoutAlign="left" class="spinner-container">
        <app-kd-logo-loading size="small"></app-kd-logo-loading>
    </div>
</ng-template>
